<template>
  <div class="payment">
    <div class="spelling">
       <div class="image-text">
         <div class="left">
           <img :src="goodsinfo.coverImage">
         </div>
         <div class="right">
           <p>{{goodsinfo.name}}</p>
           <span></span>
         </div>
       </div>
	   <div class="addressarea" v-if="needadress == 1">
		   <div class="address-top">该课程有配套的学习资料或协议文件需要邮寄，需填写收货信息！</div>
		   <div class="addressEmpty" v-show="addressEmpty">
				<div class="address-img" @click="addAddress"><img src="/img/address.png" width="30%"><p>点击添加收货地址</p></div>
		   </div>
		   <div class="addressinputed" v-show="!addressEmpty">
				<div class="addressing-center">
					<van-cell-group inset>
					  <van-cell title="收货人姓名:" :value="recipients" />
					  <van-cell title="收货人手机:" :value="mobile" />
					  <van-cell title="收货人地址:" :value="result+' '+address" />
					</van-cell-group>
				</div>
				<div class="addressing-bottom">
					<van-button  plain type="danger" @click="changeAddress" size="small">更换地址</van-button>
				</div>
		   </div>
	   </div>
       <div class="money">
          <div class="span1"><span class="order">订单金额：</span><span class="price">¥{{(paymentparams.totalPrice/100).toFixed(2)}}</span></div>
       </div>
    </div>
    <div class="wxpy">
        <div class="left">
			<img src="/img/weixinzhifu.png" width="22"/><span>微信支付</span>
		</div>
        <div class="right"><van-icon name="success" size="30" color="#09bb07"/></div>
    </div>
	<van-coupon-cell
	  :coupons="couponlist"
	  :chosen-coupon="chosenCoupon"
	  @click="showList = true"
	/>
	<!-- 优惠券列表 -->
	<van-popup
	  v-model="showList"
	  round
	  position="bottom"
	  style="height: 90%; padding-top: 4px;"
	>
	  <van-coupon-list
	    :coupons="couponlist"
	    :chosen-coupon="chosenCoupon"
	    :disabled-coupons="disabledCoupons"
	    @change="onChange"
	    @exchange="onExchange"
	  />
	</van-popup>
	
	<van-popup
	  v-model="showAddressEdit"
	  round
	  position="bottom"
	  style="height: 60%; padding-top: 4px;"
	>
	<div class="addressedittitle">输入收货地址</div>
	<van-cell-group >
	    <van-field
	      v-model="recipients"
	      name="收货人姓名"
	      label="收货人姓名"
	      placeholder="收货人姓名"
	    />
	    <van-field
	      v-model="mobile"
	      name="收货人手机"
	      label="收货人手机"
	      placeholder="收货人手机"
	    />
		<van-field
		  v-model="result"
		  is-link
		  readonly
		  name="area"
		  label="地区选择"
		  placeholder="点击选择省市区"
		  @click="showArea = true"
		/>
		<van-field
		  v-model="address"
		  name="收货地址"
		  label="收货地址"
		  placeholder="收货地址"
		/>
	  </van-cell-group>
	  <div style="margin: 16px;">
	    <van-button round block type="danger" @click="submitaddress">
	      提交
	    </van-button>
	  </div>
	</van-popup>
<van-popup v-model:show="showArea" position="bottom">
  <van-area
    :area-list="areaList"
    @confirm="onConfirmArea"
    @cancel="showArea = false"
  />
</van-popup>

<!-- <van-popup v-model:show="showteachererweima"
	closeable
	@closed="closeteachererweima"
	style="width: 70vw;"
	round
>
<img :src="afterimg" width="100%"/>
</van-popup> -->

<van-overlay :show="showteachererweima" @click="closeoverlay">
			<div class="wrapper">
				<div style="width: 80vw;text-align: center;" @click.stop>
					<img :src="afterimg" width="100%" /><br/>
					<van-icon name="close" size="40px" color="#ffffff" @click="closeoverlay" style="margin-top: 40px;"/>
				</div>
			</div>
</van-overlay>
	
<van-submit-bar :price="parseFloat(paymentparams.payPrice)" button-text="立即支付" label="实际支付: " @submit="orderex" />
  </div>
</template>

<script>
	import { Dialog } from 'vant';
	import { Toast } from 'vant';
	import {CookieTool} from '@/utils/cookietool'
	import qs from 'qs';
	import {api_base,api_goods,api_user} from '@/common/Request.js';
	import { areaList } from '@vant/area-data';
	var myordercallbackinfo=null;
	var mythis=null;
	const coupon = {
	  available: 1,
	  condition: '无使用门槛\n最多优惠12元',
	  reason: '',
	  value: 150,
	  name: '优惠券名称',
	  startAt: 1489104000,
	  endAt: 1514592000,
	  valueDesc: '1.5',
	  unitDesc: '元',
	};
	export default {
	  data() {
	    return{
			goodsinfo:[],
			wxorderinfo:[],
			usertoken:'',
			orderinfo_callback:'',
			trueprice:0,
			goodsid:0,
			openid:'',
			chosenCoupon: -1,
			couponlist:[],
			coupons: [coupon],
			disabledCoupons: [],
			showList:false,
			paymentparams:[],
			orderId:0,
			qd:'',
			addressEmpty:true,
			needadress:0,
			mobile:'',
			address:'',
			recipients:'',
			showAddressEdit:false,
			showArea:false,
			columns:[],
			result:'',
			areaList,
			showteachererweima:false,
			afterimg:''
			
	    }
	  },
	  mounted() {
		  this.paymentparams.payPrice=0;
		  this.paymentparams.totalPrice=0;
	  	if(this.$cookies.isKey("user_token"))
	  	{
	  		this.usertoken=this.$cookies.get("user_token");
			if(this.$route.query.goodsid){
				this.goodsid=this.$route.query.goodsid;
				this.orderinit();
			}
			else{
				Toast.fail("参数丢失，将返回微官网首页...");
				this.$router.push('/');
			}
			
	  	}
		else{
			Toast.fail("验证信息丢失，重新验证...");
			this.$router.push('/auth_new');
		}
		if(CookieTool.getCookie("huazhi_qd")!=''){
			this.qd=CookieTool.getCookie("huazhi_qd");
		}
	  },
	  methods:{
		  orderinit(){
			  let that=this;
			  if(this.goodsid>0)
			  {
				  api_goods.goods_detail(this.goodsid).then(res=>{
					  if(res.code==0){
						  console.log(res.data);
						  this.goodsinfo=res.data;
						  this.paymentparams.payType=2;
						  this.paymentparams.payPrice=this.goodsinfo.product.originalPrice;
						  this.paymentparams.totalPrice=this.goodsinfo.product.originalPrice;
						  this.needadress=res.data.product.needAddress;
						  if(this.goodsinfo.coverImage==''){
							this.goodsinfo.coverImage="/img/default.jpg";
						  }
						  if(this.goodsinfo.product.hasOwnProperty("discountPrice"))
						  { 
							  if(this.goodsinfo.product.discountStartTime<new Date().getTime()&&this.goodsinfo.product.discountEndTime>new Date().getTime())
							  {
								  this.paymentparams.payPrice=this.goodsinfo.product.discountPrice;
								  this.paymentparams.totalPrice=this.goodsinfo.product.discountPrice;
							  }
						  }
						  api_user.coupon_list_condition(this.goodsinfo.product.id).then(rescoupon=>{
								 console.log(rescoupon);
								  that.couponlist=rescoupon.data;
								  that.filtercoupon(that.couponlist);
								  console.log(that.couponlist);
						  });
					  }
				  });
				  

			  }
			  else{
				  Dialog.confirm({
				    title: '注意',
				    message:"参数出错请返回重试！",
				  })
				    .then(() => {
				      // on confirm 
				    })
				    .catch(() => {
				      // on cancel
				  	//Toast('操作已取消！')
				    });
			  }
		  },
		  wxpay(order_callback){
			  this.openid=this.$cookies.get("wx_token");
			  api_user.wxpay(order_callback.order_sn,order_callback.order_amount,this.openid).then(res=>{
				  console.log(res);
				  this.wxorderinfo=res.data;
				  this.callpay();
			  });
		  },
		  callpay()
		  {
		  	if (typeof WeixinJSBridge == "undefined"){
		  	if( document.addEventListener ){
		  		document.addEventListener('WeixinJSBridgeReady', this.jsApiCall, false);
		  	}else if (document.attachEvent){
		  		document.attachEvent('WeixinJSBridgeReady', this.jsApiCall);
		  		document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall);
		  	}
		  	}else{
		  		this.jsApiCall();
		  	}
		  },
		  jsApiCall(){
		  	mythis=this;
		  		WeixinJSBridge.invoke(
		  		'getBrandWCPayRequest',
		  		this.wxorderinfo,
		  		function(res){
		  			WeixinJSBridge.log(res.err_msg);
		  			if(res.err_msg=="get_brand_wcpay_request:ok")
		  			 {
						const time = setInterval(()=>{
						    api_user.getPayStatus(mythis.orderId).then(res=>{
						        if(res.code == 0){
									//alert(res);
						            if(res.data == 1) {
										clearInterval(time);
						                Toast.success("支付成功");
										console.log("pay1")
						                // mythis.$router.push("/usercenter");
						            }
						        }
						    })
						 },1000)
						 
						 // api_user.pay(myordercallbackinfo.order_id,myordercallbackinfo.order_amount).then(response => {
		  			// 	 	console.log(response);
		  			// 		Toast.success("支付成功");
		  			// 		mythis.$router.push("/usercenter");
		  			// 	 });
		  				 //location.href="http://www.witsun.cn/weixin/WxpayAPI/pay/return_urls.php?out_trade_no=<?php echo $order_num; ?>"
		  			 }
		  			//alert(res.err_code+res.err_desc+res.err_msg);
		  		}
		  	);
		  },
		  order(){
			  api_user.wxorder(this.usertoken,this.goodsid,0,4,this.qd).then(res=>{
				  console.log(res.data);
				  this.orderinfo_callback=res.data;
				  myordercallbackinfo=res.data;
				  if(this.orderinfo_callback.order_amount!=0)
				  {
				  	this.wxpay(res.data);
				  }
				  else{
					  api_user.pay_zero(this.orderinfo_callback.order_id).then(pay_response=>{
						  console.log(pay_response);
						  if(pay_response.code==0){
							  Toast.success("购买成功！");
							  console.log("pay2")
							  // this.$router.push({
							  //   path: "/usercenter"
							  // });
						  }
						  else{
							  Toast.fail("非零元课程无法购买！");
						  }
					  });
				  }
				  
			  });
		  },
		      onChange(index) {
		        this.showList = false;
		        this.chosenCoupon = index;
				console.log(this.chosenCoupon);
				console.log(this.goodsinfo.product);
				
				if(this.chosenCoupon==-1){
									  if(this.paymentparams.payPrice==0)
									  {
										  this.paymentparams.payType=0;
									  }
									  else{
										  console.log("dic")
										  this.paymentparams.payPrice=this.goodsinfo.product.originalPrice;
										  if(this.goodsinfo.product.hasOwnProperty("discountPrice"))
										  { 
											  if(this.goodsinfo.product.discountStartTime<new Date().getTime()&&this.goodsinfo.product.discountEndTime>new Date().getTime())
											  {
												  this.paymentparams.payPrice=this.goodsinfo.product.discountPrice;
											  }
										  }
									  }
				}
				else{
									  let moneyCond=this.couponlist[this.chosenCoupon].moneyCond;
									  let discountmoney=this.couponlist[this.chosenCoupon].discountMoney;
									  this.paymentparams.payPrice=this.goodsinfo.product.originalPrice;
									  this.paymentparams.userCouponId=this.couponlist[this.chosenCoupon].userCouponId;
									  console.log(this.paymentparams.payPrice);
									  if(this.goodsinfo.product.hasOwnProperty("discountPrice"))
									  { 
										  console.log("has discountprice")
									  						  if(this.goodsinfo.product.discountStartTime<new Date().getTime()&&this.goodsinfo.product.discountEndTime>new Date().getTime())
									  						  {
									  							  this.paymentparams.payPrice=this.goodsinfo.product.discountPrice;
									  						  }
									  }
									  if(this.paymentparams.payPrice>=moneyCond){
										  console.log("moneycond");
										  this.paymentparams.payPrice=this.paymentparams.payPrice-discountmoney;
										  if(this.paymentparams.payPrice<0){
											  this.paymentparams.payPrice=0;
											  this.paymentparams.payType=0;
										  }
										  else{
											  this.paymentparams.payType=2
										  }
									  }
				}
				
		      },
		      onExchange(code) {
		        this.coupons.push(coupon);
		      },
			  orderex(){
				  
				  this.paymentparams.productId=this.goodsinfo.product.id
				  this.paymentparams.source=5;
				  this.paymentparams.payType=2;
				  
				  if(this.paymentparams.payPrice==0)
				  {
				  	this.paymentparams.payType=0;
				  }
				  if(this.qd!=''){
					  this.paymentparams.qd=this.qd;
				  }
				  
				  if(this.needadress==1){
					  if(this.recipients!=''){
						  this.paymentparams.recipients=this.recipients;
					  }
					  else{
						  Dialog.alert({
						    title: '注意',
						    message: '收货人不能为空',
						  }).then(() => {
						    // on close
						  });
						  return ;
					  }
					  
					  if(this.mobile!=''){
						  this.paymentparams.mobile=this.mobile;

					  }
					  else{
						  Dialog.alert({
						    title: '注意',
						    message: '收货人手机不能为空',
						  }).then(() => {
						    // on close
						  });
						  return ;
					  }
					  
					  if(this.address!=''){
					  	  this.paymentparams.address=this.result+" "+this.address;
					  }
					  else{
						  Dialog.alert({
						    title: '注意',
						    message: '收货地址不能为空',
						  }).then(() => {
						    // on close
						  });
						  return ;
					  }
					  
				  }
				  
				  
				  console.log(this.paymentparams);
				  let arr2str=qs.stringify(this.paymentparams);
				  api_user.wxorder(arr2str).then(res=>{
					  console.log(res);
					  if(res.code==0){
						  this.orderId=res.data.orderId;
						  if(this.paymentparams.payPrice>0){
							  api_user.wxpay(res.data.orderId).then(response=>{
													  console.log(response);
													  this.wxorderinfo=response.data;
													  this.callpay();
													  //this.completepay();
							  })
						  }
						  else
						  {
							  this.completepay();
						  }
					  }
					  else if(res.code==-403){
						  this.$cookies.remove("user_token");
						  this.$cookies.remove("mobile");
						  this.$cookies.remove("userId");
						  this.$router.push('/auth_new');
					  }
					  else{
						  Dialog.alert({
						    title: '支付出错',
						    message: res.msg,
						  }).then(() => {
						    // on close
						  });
					  }
					  
					  
				  })
			  },
		filtercoupon(couponlist){
			for(var couponindex in couponlist)
			{
				couponlist[couponindex].available=1;
				couponlist[couponindex].value=couponlist[couponindex].discountMoney;
				couponlist[couponindex].unitDesc='元';
				couponlist[couponindex].valueDesc=(couponlist[couponindex].discountMoney/100).toFixed(2);
				if(couponlist[couponindex].moneyCond==0){
					couponlist[couponindex].condition="无门槛使用";
				}
				else{
					couponlist[couponindex].condition="单笔满"+(couponlist[couponindex].moneyCond/100).toFixed(2)+"元使用";
				}
				couponlist[couponindex].startAt=couponlist[couponindex].startUseTime/1000;
				couponlist[couponindex].endAt=couponlist[couponindex].endUseTime/1000;
			}
		},
		completepay(){
			console.log(this.orderId);
			mythis=this;
			const time = setInterval(()=>{
			    api_user.getPayStatus(this.orderId).then(res=>{
					console.log(res);
			        if(res.code == 0){
			            if(res.data == 1) {
							clearInterval(time);
			                Toast.success("支付成功");
							console.log(mythis.goodsid);
							api_user.getAfterBuyShowImgUrl(mythis.goodsid).then(afres=>{
								if(afres.code==0){
									console.log(afres);
									mythis.showteachererweima=true;
									mythis.afterimg=afres.data;
								}
							})
							
							console.log("pay3")
			                //mythis.$router.push("/usercenter");
			            }
			        }
			    })
			 },1000)
		},
		addAddress(){
			this.showAddressEdit=true;
		},
		changeAddress(){
			this.showAddressEdit=true;
		},
		submitaddress(){
			this.showAddressEdit=false;
			this.addressEmpty=false;
		},
		onConfirmArea(areaValues){
			      this.showArea = false;
			      this.result = areaValues
			        .filter((item) => !!item)
			        .map((item) => item.name)
			        .join('/');
		},
		closeoverlay(){
			this.$router.push('/usercenter');
		}  
	  }
	}
</script>

<style scoped>
  .payment {
  position: relative;
  background-color: #f3f3f3;
}
  .spelling {
    margin-bottom: .625rem /* 10/16 */;
    /* height: 11rem ; */
    width: 100%;
    background-color: #fff;
    margin-bottom: .625rem /* 10/16 */;
    box-sizing: border-box;
  }
  .spellings {
    margin-top: .3125rem /* 5/16 */;
    height: 13.125rem /* 210/16 */;
    width: 100%;
    background-color: #fff;
  }
  .image-text {
    padding-top: .75rem /* 12/16 */;
    height: 7.5rem /* 120/16 */;
    width: 100%;
	display: flex;
    /* background-color: pink; */
/*    border-bottom: 1px solid #f3f3f3; */
  }
  .image-text .left {
    height: 5.375rem /* 86/16 */;
	flex:0 0 50%;
    /* background-color: yellow; */
    padding-left: .9375rem /* 15/16 */;
  }
  .image-text .left img {
    width: 100%;
  }
  .image-text .right {
    height: 5.375rem /* 86/16 */;
    flex:0 0 40%;
    /* background-color: green; */
    padding-left: .625rem /* 10/16 */;
  }
  .image-text .right p {
    font-size: .875rem /* 14/16 */;
    height: 2.5rem /* 40/16 */;
  }
  .image-text .right span {
    font-size: .75rem /* 12/16 */;
    color: #A9A9A9;
  }
  .money {
    height: 2.8125rem /* 45/16 */;
    width: 100%;
	border-top:1px solid #f3f3f3;
    border-bottom: 1px solid #f3f3f3;
    line-height: 2.8125rem /* 45/16 */;
  }
   .money .span1 {
     float: right;
     margin-right: .9375rem /* 15/16 */;
   }
  .money .order {
    font-size: .75rem /* 12/16 */;
    color: #333333;
  }
  .money .price {
    font-size: 1.125rem /* 18/16 */;
  }
  .wxpy {
    box-sizing: border-box;
    padding-top: 0.9375rem;
	padding-bottom: 0.9375rem;
    background-color: #fff;
	position: relative;
	border-bottom: solid 1px #fafafa;
  }
  .wxpy span {
    font-size: .8125rem /* 13/16 */;
  }
  .wxpy .left {
	   /*width: 5rem /* 22/16 */;
    margin-left: 1.25rem /* 20/16 */;
  }
  
  .wxpy .left img{
	  vertical-align: middle;
  }
  .wxpy .left span{
	  margin-left: 0.625rem;
  }
  .wxpy .right {
    width: 1.375rem /* 22/16 */;
    height: 1.25rem /* 20/16 */;
	top:0.625rem;
	right:2.5rem;
	position: absolute;
  }
  .footer {
    position: fixed;
    bottom: 0rem;
    line-height: 3.0625rem /* 49/16 */;
    height: 3.0625rem /* 49/16 */;
    width: 23.4375rem /* 375/16 */;
    font-size: .75rem /* 12/16 */;
  }
  .footer-left {
    text-align: center;
    width: 14.0625rem /* 225/16 */;
    height: 100%;
    background-color: #fff;
    float: left;
  }
  .footer-left .span1 {
    color: #666;
  }
  .footer-left .span2 {
    color: #FE5A59;
  }
  .footer-right {
    color: #fff;
    text-align: center;
    height: 100%;
    width: 9.375rem /* 150/16 */;
    background-color: #FE5A59;
    float: right;
  }
  .address-top{
	  text-align: center;
	  margin-top: 0.625rem;
	  margin-bottom: 0.625rem;
	  font-weight: bold;
  }
  .address-img{
	  text-align: center;
	  font-size: 14px;
  }
  .addressEmpty{
	  margin-top: 0.625rem;
	  margin-bottom: 0.625rem;
  }
  
  .addressedittitle{
	  margin-top: 0.625rem;
	  margin-bottom: 0.625rem;
	  font-size: 18px;
	  font-weight: bold;
	  text-align: center;
  }
  
  .addressing-bottom{
	  margin: 16px;
	  text-align: center;
  }
  .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
  
</style>
